export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe35f0b92738805aed81e8e9172dd0fb623b7c0eb&name=fetchTypeahead!'